import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { LanguageService } from './language.service';
import { SessionExpiredHandler } from './session-expired-handler.service';
import { SessionService } from './session.service';

@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(
    private _session: SessionService,
    private _expiredSession: SessionExpiredHandler
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let _headers = req.headers;
    const culture = LanguageService.getCultureLang();
    if (culture) {
      _headers = req.headers.set('Accept-Language', culture);
    }

    const token = this._session.token;
    if (token) {
      _headers = _headers.append('Authorization', `Bearer ${token}`);

      if (req.detectContentTypeHeader() == 'text/plain') {
        _headers = _headers.set('Content-Type', 'application/json');
      }

      const authReq = req.clone({ headers: _headers });
      return next.handle(authReq).pipe(catchError(error => this.handleUnauthorized(error)));
    }
    return next.handle(req).pipe(catchError(error => this.handleUnauthorized(error)));
  }

  /**
   * A 401 while a session is stored means the session is no longer valid server side (expired or revoked),
   * so sign out and send the user to the login screen instead of leaving the app half working.
   * Requests made without a session (the token endpoint, the login screen) are left alone.
   */
  private handleUnauthorized(error: unknown): Observable<never> {
    if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.Unauthorized) {
      this._expiredSession.handle();
    }
    return throwError(() => error);
  }
}
